export const presenceList = [
  {
    icon: "presence-1",
    key: "400006", //400006
    title: "300240",
    tag: "Q1",
    desc:
      "300241"  //300241
  },
  {
    icon: "presence-2",
    key: "400007",  //400007
    title: "300242",
    tag: "Q2",
    desc:
      "300243"
  },
  {
    icon: "presence-3",
    key: "400008",   //400008
    title: "300244", 
    tag: "Q3",
    desc:
      "300245"
  },
  {
    icon: "presence-4",
    key: "400009",    //400009
    title: "300246", 
    tag: "Q4",
    desc:
      "300247"
  }
];



// WEBPACK FOOTER //
// ./src/data/presence.js